/**
 * Cookie + legacy key name: pathname + search to return to after LinkedIn VoL OAuth
 * when starting from pre-apply (or similar). The **cookie** is read by
 * `/api/linkedin-vol/oauth-callback` (server); client clears it on cancel.
 */
export const LINKEDIN_VOL_POST_VERIFY_RETURN_PATH_KEY =
  'linkedin_vol_post_verify_return_path';

/**
 * Cookie: profile id for the LinkedIn identity (government-ID) journey. Read by
 * `/api/linkedin-vol/verify-identity-return` (server) so it can re-enter the
 * OAuth flow with `intent=identity_recheck` when LinkedIn sends the member back
 * after completing verification.
 */
export const LINKEDIN_VOL_IDENTITY_PROFILE_ID_KEY =
  'linkedin_vol_identity_profile_id';
